import { Component, OnInit, AfterViewInit } from '@angular/core';
declare var AOS: any;
@Component({ selector: 'app-sdk-iot', templateUrl: './iot-sdk.component.html', styleUrls: ['./iot-sdk.component.scss'], standalone: false })
export class IoTSDKComponent implements OnInit, AfterViewInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Features', icon: 'bx-chip' },
    { id: 'integration', label: 'Integration', icon: 'bx-code-alt' },
  ];
  features = [
    { icon: 'bx-chip', title: 'Embedded C/C++ Library', desc: 'Lightweight embedded library for RTOS and bare-metal ECU environments with minimal memory footprint.' },
    { icon: 'bx-network-chart', title: 'Protocol Adapters', desc: 'Built-in adapters for CAN Bus, J1939, OBD-II, MQTT, and CoAP for hardware vendor independence.' },
    { icon: 'bx-time', title: 'Edge Processing', desc: 'Local data filtering, compression, and batch upload to minimise cellular data usage on devices.' },
    { icon: 'bx-refresh', title: 'OTA Agent', desc: 'Integrated OTA firmware update agent supporting delta updates, rollback, and integrity verification.' },
    { icon: 'bx-shield', title: 'Hardware Security', desc: 'Hardware-root-of-trust, secure boot, and certificate-based mutual TLS for device identity.' },
    { icon: 'bx-cog', title: 'Remote Config', desc: 'Twin-based device shadow for remote configuration, parameter updates, and policy enforcement.' },
  ];
  ngOnInit() {}
  ngAfterViewInit() { try { AOS.refresh(); } catch (e) {} }
  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
